// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "1.5.47/static/js/" + chunkId + "." + {"109":"231a117d","178":"a143c678"}[chunkId] + ".chunk.js";
};